import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../i18n/useTranslation';

const GDPRConsentPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [consentChecked, setConsentChecked] = useState(false);

  const handleAccept = () => {
    if (consentChecked) {
      localStorage.setItem('gdpr-consent-given', 'true');
      navigate('/camera');
    }
  };

  return (
    <div style={{
      width: '100%',
      minHeight: '100vh',
      backgroundColor: '#f5f5f5',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{
        width: '100%',
        maxWidth: '600px',
        backgroundColor: 'white',
        borderRadius: '16px',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
        overflow: 'hidden'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          padding: '20px 24px',
          borderBottom: '1px solid #e0e0e0',
          backgroundColor: '#ffffff'
        }}>
          <h1 style={{
            fontSize: '24px',
            fontWeight: 600,
            color: '#2c3e50',
            margin: 0
          }}>
            {t('gdpr.pageTitle')}
          </h1>
        </div>

        <div style={{ padding: '32px 24px' }}>
          <div style={{ marginBottom: '32px' }}>
            <p style={{
              fontSize: '16px',
              lineHeight: 1.6,
              color: '#2c3e50',
              marginBottom: '24px'
            }}>
              {t('gdpr.introBeforeLink')}{' '}
              <span style={{
                color: '#3498db',
                textDecoration: 'underline',
                cursor: 'pointer'
              }}>
                {t('gdpr.clarificationLink')}
              </span>{' '}
              {t('gdpr.introAfterLink')}
            </p>
            
            <div style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: '12px'
            }}>
              <input
                type="checkbox"
                id="gdpr-consent"
                checked={consentChecked}
                onChange={(e) => setConsentChecked(e.target.checked)}
                style={{
                  width: '20px',
                  height: '20px',
                  marginTop: '2px',
                  cursor: 'pointer',
                  flexShrink: 0
                }}
              />
              <label
                htmlFor="gdpr-consent"
                style={{
                  fontSize: '16px',
                  lineHeight: 1.5,
                  color: '#2c3e50',
                  cursor: 'pointer',
                  userSelect: 'none'
                }}
              >
                {t('gdpr.checkboxLabel')}
              </label>
            </div>
          </div>
          
          <button
            onClick={handleAccept}
            disabled={!consentChecked}
            style={{
              width: '100%',
              padding: '14px 24px',
              backgroundColor: consentChecked ? '#2c3e50' : '#cccccc',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '16px',
              fontWeight: 600,
              cursor: consentChecked ? 'pointer' : 'not-allowed',
              transition: 'background-color 0.3s ease',
              opacity: consentChecked ? 1 : 0.5
            }}
          >
            {t('gdpr.continueCamera')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default GDPRConsentPage;